module.exports = "<div class=\"container w-xxl w-auto-xs\"><div class=\"text-center m-b-lg\"><h1 class=\"text-shadow text-white\">403</h1><div class=\"h4 text-muted\">Unauthorised Access</div></div><div class=\"list-group bg-info auto m-b-sm m-b-lg\"><a class=\"list-group-item\" ui-sref=\"main.dashboard\"><i class=\"fa fa-chevron-right text-muted\"></i><i class=\"fa fa-fw fa-mail-forward m-r-xs\"></i>Goto Dashboard</a></div><footer></footer></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/four-o-three/four-o-three.pug
// module id = 271
// module chunks = 0